import { isMobile } from "../utils";
const doWindow = window;
export default class SpecialCardFields {
    constructor(data) {
        this.initialize = () => {
            const descriptions = this._cardsContainer.querySelectorAll(".card__description");
            for (const desc of descriptions) {
                if (desc.clientHeight > 200) {
                    this.addReadMoreToggle(desc);
                }
            }
            const disclaimerButtons = this._cardsContainer.querySelectorAll(".viewDisclaimerToggle");
            for (const btn of disclaimerButtons) {
                btn.addEventListener("click", this.toggleDisclaimer);
            }
            const specialFormCtas = this.getCtas(".get-special-form");
            for (const cta of specialFormCtas) {
                cta.addEventListener("click", () => this.toggleLeadForm(cta));
            }
            const printCtas = this.getCtas(".print-button");
            const printImages = Array.from(document.querySelectorAll(".hero-print-button"));
            for (const cta of [printCtas, printImages].flat()) {
                cta.addEventListener("click", () => this.printSpecial(cta));
            }
        };
        this.addReadMoreToggle = (elem) => {
            elem.classList.add("card__body--truncate");
            const button = document.createElement("button");
            button.type = "button";
            button.classList.add("btn", "card__body--read-more-btn", "stat-expand-icon");
            button.dataset.loc = "special card";
            button.textContent = this._readMoreButtonText;
            button.addEventListener("click", this.toggleDescription);
            elem.appendChild(button);
        };
        this.printSpecial = (cta) => {
            const userAgent = navigator.userAgent.toLowerCase() ?? "";
            const isSafari = userAgent.includes("safari") && !userAgent.includes("chrome");
            if (isSafari) {
                const card = cta.closest(".card__coupon");
                if (!card)
                    return;
                card.classList.add("print");
                const cardClone = card.cloneNode(true);
                const printWindow = window.open("", "_blank", "width=800,height=600");
                if (!printWindow)
                    return;
                printWindow.document.open();
                printWindow.document.write("<!DOCTYPE html><html><head><title>Print Special</title><style>" +
                    this.safariPrintStyles() +
                    `</style></head><body class="displayPrint"></body></html>`);
                printWindow.document.close();
                printWindow.document.body.appendChild(cardClone);
                const printAddress = document.querySelector(".print-address");
                if (printAddress) {
                    const addressClone = printAddress.cloneNode(true);
                    printWindow.document.body.appendChild(addressClone);
                }
                printWindow.focus();
                setTimeout(function () {
                    printWindow.print();
                    printWindow.close();
                    card.classList.remove("print");
                }, 250);
            }
            else {
                const printElems = Array.from(document.getElementsByClassName("print"));
                for (const elem of printElems) {
                    elem.classList.remove("print");
                }
                const card = cta.closest(".card__coupon");
                card.classList.add("print");
                let parent = card.parentElement;
                while (parent) {
                    parent.classList.add("displayPrint");
                    parent = parent.parentElement;
                }
                window.addEventListener("afterprint", () => this.removePrintClasses(card), { once: true });
                window.print();
            }
        };
        this.safariPrintStyles = () => {
            return `
      .card__actions {
        display: none;
      }

      html {
        height: auto;
      }

      .wrapper {
        display: flex;
        flex-direction: column;
      }

      .print {
        margin-left: 0 !important;
      }

      .print-address {
        margin-top: 24px;
        font-size: 16px;
        color: #222;
      }

      .card__coupon {
        max-width: 600px;
        margin: auto;
        border: 1px solid #eee;
        padding: 16px;
        background: #fff;
      }

      .card__title--main {
        font-size: 1.5em;
        margin-bottom: 8px;
      }

      .card__offerValue,
      .card__expiration,
      .card__description-expanded,
      .card__disclaimer {
        margin-bottom: 8px;
      }

      @media print {
        body.displayPrint *:not(.print) {
          display: none;
        }

        .card__coupon.print {
          padding: 6px;
          border: 2px dashed #888;
        }

        .card__hero img {
          max-width: 100%;
          height: auto;
        }

        .displayPrint,
        .card__coupon.print,
        .card__coupon.print *,
        .print-address,
        .print-address *,
        .slp-col {
          display: block !important;
        }

        .print-address span[class*="callNowClass"] {
          display: inline-block;
        }

        .card__coupon.print .card__actions,
        .card__coupon.print .card__face--alt {
          display: none !important;
        }

        .card__wrapper--2.card__coupon.print {
          width: 50%;
        }

        .card__wrapper--3.card__coupon.print {
          width: 33%;
        }

        .slp-col.displayPrint,
        .even__cols.displayPrint {
          width: 100%;
        }

        .card .card__description.card__body--truncate {
          max-height: unset;
        }

        .card__coupon.print .viewSpDisclaimer,
        .card__coupon.print .card__body--read-more-btn {
          display: none !important;
        }

        .print .card__disclaimer {
          height: auto !important;
        }

        .card__coupon.print {
          display: block;
          margin: 0 auto 1in auto;
          padding: 20px;
          max-width: 400px;
        }

        .print-address {
          margin-top: 12px;
          font-size: 14px;
          text-align: left;
        }
      }
    `;
        };
        this.removePrintClasses = (card) => {
            card.classList.remove("print");
            let parent = card.parentElement;
            while (parent) {
                parent.classList.remove("displayPrint");
                parent = parent.parentElement;
            }
        };
        this.toggleDescription = (e) => {
            const btn = e.currentTarget;
            const desc = btn.parentElement;
            if (btn.classList.contains("card__body--read-more-btn")) {
                desc.classList.replace("card__body--truncate", "card__body--read");
                btn.classList.replace("card__body--read-more-btn", "card__body--read-less-btn");
                btn.textContent = this._readLessButtonText;
            }
            else {
                desc.classList.replace("card__body--read", "card__body--truncate");
                btn.classList.replace("card__body--read-less-btn", "card__body--read-more-btn");
                btn.textContent = this._readMoreButtonText;
            }
        };
        this.toggleDisclaimer = (e) => {
            const btn = e.currentTarget;
            const disclaimer = btn.parentElement.previousElementSibling;
            if (disclaimer.classList.contains("hideSpDisclaimer")) {
                disclaimer.classList.remove("hideSpDisclaimer");
                btn.textContent = "Hide Disclaimer";
            }
            else {
                disclaimer.classList.add("hideSpDisclaimer");
                btn.textContent = "View Disclaimer";
            }
        };
        this.toggleLeadForm = (cta, openForm = true) => {
            const card = cta.closest(".card__coupon");
            const formContainer = card.querySelector(".card__face--alt");
            if (openForm) {
                const exitButton = formContainer.querySelector(".card__form--close");
                exitButton.addEventListener("click", () => this.toggleLeadForm(cta, false), { once: true });
            }
            const cardFace = card.querySelector(".card__face");
            if (formContainer) {
                formContainer.classList.toggle("active");
                formContainer.classList.toggle("inactive");
                cardFace.classList.toggle("active");
                cardFace.classList.toggle("inactive");
                const form = formContainer.querySelector("form");
                if (form.ctaName && !form.ctaName.value && cta.textContent) {
                    form.ctaName.value = cta.textContent;
                }
                const input = formContainer.querySelector("input.focus-anchor");
                if (input && formContainer.classList.contains("active")) {
                    input.focus();
                }
                else if (input) {
                    input.blur();
                }
                if (isMobile()) {
                    // Ewww...
                    const navHeight = doWindow.jQuery("#navbar-header").height();
                    const cardId = card.getAttribute("id");
                    doWindow.jQuery("html, body").animate({
                        scrollTop: doWindow.jQuery(`#${cardId}`).offset().top - navHeight,
                    }, 500);
                }
            }
        };
        this.getCtas = (ctaClass) => Array.from(this._cardsContainer.querySelectorAll(`.card__actions ${ctaClass}`));
        this._cardsContainer = document.getElementById("cards__Container");
        if (data) {
            this._readLessButtonText = data.readLessButtonText;
            this._readMoreButtonText = data.readMoreButtonText;
        }
        this.initialize();
    }
}
